import type { AnimalSex, AnimalSexLabel } from './Animal.model';
import { AnimalSexMap } from './Animal.model';

export const AnimalSexLabelToCode: Record<AnimalSexLabel, AnimalSex> = Object.fromEntries(
  Object.entries(AnimalSexMap).map(([code, label]) => [label, code])
) as Record<AnimalSexLabel, AnimalSex>;

export const getSexOptions = (includeUnknown: boolean): Array<{ label: AnimalSexLabel; value: AnimalSex }> =>
  (Object.entries(AnimalSexMap) as Array<[AnimalSex, AnimalSexLabel]>)
    .filter(([code]) => code !== 'u' || includeUnknown)
    .map(([value, label]) => ({ label, value }));

export const getSexDropdownSource = (includeUnknown: boolean): Array<AnimalSexLabel> =>
  getSexOptions(includeUnknown).map(({ label }) => label);

export const createSexValidator =
  (includeUnknown: boolean) =>
  (value: string, callback: (valid: boolean) => void): void => {
    const valid = value === 'Male' || value === 'Female' || (includeUnknown && value === 'Unknown');
    callback(valid);
  };
